class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    // position:fixed breaks inside transformed ancestors (main#e-main has transform).
    // Escape by moving to body directly.
    if (this.parentElement !== document.body) {
      // Remove any stale instance left in body after a section AJAX refresh
      document.querySelectorAll('body > sticky-add-to-cart').forEach(el => {
        if (el !== this) el.remove();
      });
      document.body.appendChild(this);
      return; // connectedCallback fires again after move
    }

    const allButtons = document.querySelectorAll('[data-ref="add-to-cart-button"]');
    this.atcButton = Array.from(allButtons).find(btn => !btn.closest('sticky-add-to-cart'));
    this.footer = document.querySelector('[data-ref="footer"]');
    this.freeLabel = this.querySelector('.sticky-atc__free');

    if (!this.atcButton) return;

    document.addEventListener('form:updated', (e) => {
      if (!this.freeLabel) return;
      const price = e.detail?.prices?.price ?? 0;
      this.freeLabel.textContent = price >= 3900 ? 'Livraison gratuite !' : 'Livraison offerte dès 39€';
    });

    // Delegate click to original ATC button (sticky is outside the form)
    const stickyBtn = this.querySelector('.sticky-atc__add-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.atcButton.click();
      });
    }

    // Quantity selector sync with main form
    const qtyMinus = this.querySelector('[data-action="minus"]');
    const qtyPlus  = this.querySelector('[data-action="plus"]');
    const qtyVal   = this.querySelector('.sticky-atc__qty-val');
    const mainQty  = document.querySelector('input[name="quantity"]');

    const getQty = () => mainQty ? (parseInt(mainQty.value) || 1) : 1;
    const setQty = (v) => {
      v = Math.max(1, v);
      if (mainQty) mainQty.value = v;
      if (qtyVal) qtyVal.textContent = v;
    };
    if (qtyVal) qtyVal.textContent = getQty();
    if (qtyMinus) qtyMinus.addEventListener('click', () => setQty(getQty() - 1));
    if (qtyPlus)  qtyPlus.addEventListener('click', () => setQty(getQty() + 1));

    // Dynamic delivery dates (7–12 business days from today)
    const datesEl = this.querySelector('.sticky-atc__dates');
    if (datesEl) {
      const months = ['janv.','févr.','mars','avr.','mai','juin','juil.','août','sept.','oct.','nov.','déc.'];
      const addBD = (n) => {
        let d = new Date(), count = 0;
        while (count < n) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) count++;
        }
        return d;
      };
      const fmt = d => d.getDate() + ' ' + months[d.getMonth()];
      datesEl.textContent = fmt(addBD(7)) + ' – ' + fmt(addBD(12));
    }

    const tick = () => {
      this._update();
      this._raf = requestAnimationFrame(tick);
    };
    this._raf = requestAnimationFrame(tick);
  }

  disconnectedCallback() {
    if (this._raf) cancelAnimationFrame(this._raf);
  }

  _update() {
    if (!this.atcButton) return;
    const btnRect = this.atcButton.getBoundingClientRect();
    const btnGone = btnRect.bottom <= 0 || btnRect.top >= window.innerHeight;
    const footerVisible = this.footer
      ? this.footer.getBoundingClientRect().top < window.innerHeight
      : false;
    const dialogOpen = !!document.querySelector('dialog[open]');
    const show = btnGone && !footerVisible && !dialogOpen;
    this.dataset.active = show ? 'true' : 'false';

  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
